import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';

import { NavService } from '../../../../_services/_nav.service';

import { PerfilCrezcamosGeneralComponent } from '../../../../APL/perfil-crezcamos/perfil-crezcamos-general.component';

@Component({
  selector: 'app-widget-perfil-crezcamos',
  templateUrl: './widget-perfil-crezcamos.component.html',
  styleUrls: ['./widget-perfil-crezcamos.component.scss']
})
export class WidgetPerfilCrecamosComponent implements OnInit {
  loading: boolean = true;
  funcionalidadWPECRZ: any;

  constructor(
    private diaService: DialogService,
    private navServicio: NavService,
  ) { }

  ngOnInit() {
    const funcionalidadesTodas = localStorage.getItem('funcionalidades');
    if (funcionalidadesTodas) {
      const funcionalidadesArray = JSON.parse(funcionalidadesTodas);
      const funWPECRZ = funcionalidadesArray.find((item: any) => item.codigo === 'PERCLI');
      console.log(funcionalidadesArray)
      console.log(funWPECRZ)
      this.funcionalidadWPECRZ = funWPECRZ ? funWPECRZ : null;
    } else {
      this.funcionalidadWPECRZ = null;
    }
    this.loading = false;
  }

  irPerfilCrecamos() {
    const modal = this.diaService.open( PerfilCrezcamosGeneralComponent, {
      header: this.navServicio.buscarMensaje( 'PERFILCREZCAMOS.LBL_CLIENTECREZCAMOS' ),
      width: '70%',
      styleClass: 'modal-crezcamos-perfil',
      closeOnEscape: true,
      closable: true,
      data: {}
    } );
    modal.onClose.subscribe( ( data: any ) => {} );
  }
}
